import { get5x5DateDataDefinition } from "../Testing/TestData";
import {
    DisplayEditModeTemplate,
    DisplayLayerEditModeTemplate,
    DisplayModeTemplate,
    EditModeTemplate,
    GridTestTemplate,
} from "./CommonStoryTemplates";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { DateDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/DateDataDefinition";
import { StoryNode } from "../../StoryBook/StoryData";
import React from "react";

let griddef = get5x5DateDataDefinition();

let def = new DataDefinition();
let fdef = new DateDataDefinition("date");
def.fields.push(fdef);

DataUtilities.set(def.getValueObject(), fdef.name, "2015-06-23T14:13");

let typeName = "Date";

export const DataEditorStories = [
    new StoryNode(
        () => {
            return <GridTestTemplate definition={griddef}></GridTestTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Grid",
    ),
    new StoryNode(
        () => {
            return <DisplayModeTemplate definition={def}></DisplayModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Mode",
    ),
    new StoryNode(
        () => {
            return <EditModeTemplate definition={def}></EditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayEditModeTemplate definition={def}></DisplayEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Edit Mode",
    ),
    new StoryNode(
        () => {
            return <DisplayLayerEditModeTemplate definition={def}></DisplayLayerEditModeTemplate>;
        },

        "Shared",
        "Data Designer",
        "Data Editing",
        typeName,
        "Display Layer Edit Mode",
    ),
];
